import React from "react";
import FormReference from "./FormReference";
import AddButton from "./element/AddButton";
import DeleteButton from "./element/DeleteButton";

function FormReferences({ id, references, updateData, addData, removeData }) {
  function handleAdd() {
    addData({ category: "reference", mainId: id });
  }
  function handleDelete() {
    removeData({ category: "formExperience", mainId: id });
  }
  return (
    <>
      <div className="form-reference mb-4">
        {" "}
        <div className="flex items-center pb-2 gap-4">
          <div className="text-base font-semibold">Reference</div>{" "}
          <DeleteButton handleDelete={handleDelete} />
        </div>
        <div className="input-container">
          {" "}
          {references.items.map((reference, index) => {
            return (
              <FormReference
                key={reference.id}
                itemId={index}
                reference={reference}
                referenceId={id}
                updateData={updateData}
                removeData={removeData}
              />
            );
          })}
          <AddButton handleAdd={handleAdd} text={"+ reference item"} />
        </div>
      </div>
    </>
  );
}

export default FormReferences;
